window.MyStoriesProxy = function () {
    
    function loadUserStories(successCallback, failCallback) {
        Helpers.perfJSonCall({
            method: "GetUserStories",
            message: "Loading stories...",
            successCallback: function (stories) {
                if (successCallback) successCallback(stories);
            },
            failCallback: function () {
                if (failCallback) failCallback();
            },
            service: "MyStory",
            fixCasing: true
        });
    }

    function saveNewStory(story, successCallback, failCallback) {
        Helpers.perfJSonCall({
            data: { story: story },
            method: "SaveStory",
            message: "Saving story...",
            successCallback: function (storyId) {
                story.storyId = storyId;
                if (successCallback) successCallback(story);
            },
            failCallback: failCallback,
            service: "MyStory"
        });
    }

    function renameStory(story, name, successCallback) {
        Helpers.perfJSonCall({
            data: { storyId: story.storyId, name: name },
            method: "RenameStory",
            message: "Saving story...",
            successCallback: function () {
                if (successCallback) successCallback();
            },
            service: "MyStory"
        });
    }
    
    function saveStoriesOrder(orderedStoriesIds, successCallback) {
        Helpers.perfJSonCall({
            data: { orderedStoriesIds: orderedStoriesIds },
            method: "SaveStoriesOrder",
            message: "Saving stories order...",
            successCallback: function () {
                if (successCallback) successCallback();
            },
            service: "MyStory"
        });
    }

    function deleteStory(story, successCallback) {
        Helpers.perfJSonCall({
            data: { storyId: story.storyId },
            method: "DeleteStory",
            message: "Deleting story...",
            successCallback: function () {
                if (successCallback) successCallback();
            },
            service: "MyStory"
        });
    }

	function saveNewSlide(slide, successCallback, failCallback) {
		var data = { slide: slide };
		var method = "SaveSlide";

		if (window.ContentType > 0 && window.ContentType === Storyboard.Constants.itemTypes.CHART) {
			slide.sourceSlideId = 0;
			slide.chartCreatorSlide = true;

			data.layoutSlide = Storyboard.LayoutDesigner.getCurrentSlide();
			data.layoutElements = Storyboard.LayoutDesigner.getLayoutElementsBySlide(data.layoutSlide);
			method = "SaveChartCreatorSlide";
		}

        Helpers.perfJSonCall({
            data: data,
			method: method,
            message: "Saving slide...",
            successCallback: function (savedSlide) {
                slide.slideId = savedSlide.slideId;
                slide.settingsText = savedSlide.settingsText;
                slide.sourceReportName = HTMLHelpers.htmlEncode(savedSlide.sourceReportName);

                if (successCallback) successCallback(savedSlide);
            },
            failCallback: failCallback,
            service: "MyStory",
            fixCasing: true
        });
	}

    function renameSlide(slide, name, successCallback) {
        Helpers.perfJSonCall({
            data: { slideId: slide.slideId, name: name },
            method: "RenameSlide",
            message: "Saving slide...",
            successCallback: function () {
                if (successCallback) successCallback();
            },
            service: "MyStory"
        });
    }
    
    function saveSlidesOrder(orderedSlidesIds, successCallback) {
        Helpers.perfJSonCall({
            data: { orderedSlidesIds: orderedSlidesIds },
            method: "SaveSlidesOrder",
            message: "Saving slides order...",
            successCallback: function () {
                if (successCallback) successCallback();
            },
            service: "MyStory"
        });
    }

    function removeSlides(storyId, slides, successCallback) {
        var slideIds = slides.map(function(slide) { return slide.slideId; });

        Helpers.perfJSonCall({
            data: { storyId: storyId, slideIds: slideIds },
            method: "RemoveSlides",
            message: "Removing slides...",
            successCallback: function () {
                if (successCallback) successCallback();
            },
            service: "MyStory"
        });
	}

	function getStoryExportSettings(storyId, successCallback) {
		Helpers.perfJSonCall({
			data: { storyId: storyId },
			method: "GetStoryExportSettings",
			message: "Getting story export settings...",
			successCallback: function (storySettings) {
				if (successCallback) successCallback(storySettings);
			},
			service: "MyStory",
			fixCasing: true
		});
	}

	function getSlideThumbnailState(slideId, successCallback) {
		Helpers.perfJSonCall({
			data: { slideId: slideId },
			method: "GetSlideThumbnailState",
			successCallback: function (status) {
				if (successCallback) successCallback(slideId, status);
			},
			service: "MyStory",
			fixCasing: true
		});
    }

    function updateStoryThumbnails(storyId, successCallback) {
        Helpers.perfJSonCall({
            data: { storyId: storyId },
            method: "UpdateThumbnails",
            successCallback: function () {
                if (successCallback) successCallback();
            },
            service: "MyStory",
            fixCasing: true
        });
    }

    function getSlideSettingsText(slide, successCallback) {
        Helpers.perfJSonCall({
            data: { storyId: slide.storyId, slideId: slide.slideId },
            method: "GetStorySlideSettingsText",
            successCallback: function (settingsText) {
                if (successCallback) successCallback(settingsText);
            },
            service: "MyStory",
            message: "Loading slide settings...",
            fixCasing: true
        });
    }

    return {
        loadUserStories: loadUserStories,

        saveNewStory: saveNewStory,
        deleteStory: deleteStory,
        renameStory: renameStory,
        saveStoriesOrder: saveStoriesOrder,
        updateStoryThumbnails: updateStoryThumbnails,
        getStoryExportSettings: getStoryExportSettings,
        getSlideSettingsText: getSlideSettingsText,

        saveNewSlide: saveNewSlide,
        removeSlides: removeSlides,
        renameSlide: renameSlide,
		saveSlidesOrder: saveSlidesOrder,
		getSlideThumbnailState: getSlideThumbnailState
    };
}();